<template>
  <div>
    <page-section :title="$t('Integrations_Title_Information')">
      <form-section
        v-loading="syncTimeLoading"
        :description="$t('Integrations_ActiveDirectory_Text_NextScheduledTime')"
      >
        <span class="sync-date">
          {{ nextSyncTime !== '' ? syncDate : $t('Integrations_Text_NotSet') }}
        </span>
      </form-section>
    </page-section>

    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="[
        'active_directory_profiles_sync',
        'active_directory_lists_sync'
      ]"
    />
  </div>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, projectTimezoneDate } from '@/core/helpers'

export default {
  name: 'ActiveDirectoryOverview',

  components: {
    PageSection,
    FormSection,
    IntegrationTasksTable
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      nextSyncTime: '',
      syncTimeLoading: false
    }
  },

  mounted() {
    if (this.model.id) {
      this.syncTimeLoading = true
      let asyncDateEndpoint = projectEndpoint({
        method: 'get',
        url: `integrations/active-directory/${this.model.id}/next-sync-date`
      })
      RestApi(asyncDateEndpoint)
        .then(({ data }) => {
          this.nextSyncTime = data
          this.syncTimeLoading = false
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.syncTimeLoading = false
        })
    }
  },

  computed: {
    syncDate() {
      return projectTimezoneDate(this.nextSyncTime).format(
        'DD MMM YYYY HH:mm:ss'
      )
    }
  }
}
</script>

<style scoped>
.sync-date {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/activedirectory/ActiveDirectoryOverview.vue